<template>
    <div ref="usersStatsListContainer" class="container mb-5">

        <div class="k-tabs">
            <ul class="k-tabs__list">
                <li @click="tabChanged('last24')" class="k-tabs__item" :class="[{'k-tabs__item--active' : activeTab === 'last24'}]"><a href="javascript:;" class="k-tabs__link">Posledních 24 hodin</a></li>
                <li @click="tabChanged('lastMonth')" class="k-tabs__item" :class="[{'k-tabs__item--active' : activeTab === 'lastMonth'}]"><a href="javascript:;" class="k-tabs__link ">Poslední měsíc</a></li>
                <li @click="tabChanged('total')" class="k-tabs__item" :class="[{'k-tabs__item--active' : activeTab === 'total'}]"><a href="javascript:;" class="k-tabs__link ">Celkem</a></li>
            </ul>
        </div>

        <template v-if="users.data && users.data.length > 0">
            <div class="k-table k-table--user-stats">

                <div class="k-table__header">
                    <div class="k-table__cell">
                        Jméno
                    </div>

                    <div class="k-table__cell k-table__cell--meta-lg">
                        Počet přihlášení
                    </div>

                    <div class="k-table__cell k-table__cell--meta">
                        Dokumenty
                    </div>

                    <div class="k-table__cell k-table__cell--meta">
                        Příspěvky
                    </div>

                    <div class="k-table__cell k-table__cell--meta">
                        Komentáře
                    </div>

                </div>


                <transition-group name="list-complete" tag="div">
                    <div v-for="user in users.data" :key="user.id" class="k-table__row">
                        <div class="k-table__cell">
                            <div class="k-table__cell-image"><img :src="user.prev_url" alt="" height="67px"></div>
                            <a class="mr-auto" :href="user.detail_url">
                                <strong class="k-strong">{{ user.name }}</strong>
                            </a>
                        </div>

                        <div class="k-table__cell k-table__cell--meta-lg">
                            <div class="k-table__cell-meta">
                                {{ user.login_history_count }}
                            </div>
                        </div>

                        <div class="k-table__cell k-table__cell--meta">
                            <div class="k-table__cell-meta">
                                {{ user.documents_count }}
                            </div>
                        </div>

                        <div class="k-table__cell k-table__cell--meta">
                            <div class="k-table__cell-meta">
                                {{ user.discussions_count }}
                            </div>
                        </div>

                        <div class="k-table__cell k-table__cell--meta">
                            <div class="k-table__cell-meta">
                                {{ user.comments_count }}
                            </div>
                        </div>
                    </div>
                </transition-group>
            </div>

            <pagination class="mt-4" :data="users" @pagination-change-page="paginate"></pagination>

        </template>
        <template v-else>
            <div v-if="users.data && users.data.length === 0" class="k-table">
                <div class="k-table__row">
                    <div class="k-table__cell p-2 justify-content-center">
                        Nebyl nalezen žádný uživatel.
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    import Pagination from 'laravel-vue-pagination';

    export default {

        components: {
            'pagination': Pagination
        },

        props: {
            /**
             * Data url
             */
            url: {
                type: String,
                required: true
            }
        },

        data: () => ({
            users: {},
            activeTab: 'last24',
            page: 1,
            search: ''
        }),

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function(page = 1) {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.url,
                        params: {
                            page: page,
                            period: this.activeTab,
                            search: this.search
                        }
                    });

                    if (result.status === 200 && result.data) {
                        this.users = result.data;
                        this.page = page;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },

            /**
             * Paginate results
             *
             * @param page
             * @returns void
             */
            paginate: async function(page = 1) {
                await this.getData(page);
                if (this.$refs.usersStatsListContainer) {
                    setTimeout( () => {
                        this.$scrollTo(this.$refs.usersStatsListContainer, 500, {offset: -80});
                    }, 300);
                }
            },

            /**
             * Tab changed
             *
             * @returns void
             */
            tabChanged: function(value) {
                if (this.activeTab !== value) {
                    this.activeTab = value;
                    // get data and keep current page
                    this.getData(this.page);
                }
            }
        },

        created() {

            window.events.$on('searchInputSubmitted', async (search) => {
                this.search = search;
                this.paginate(1);
            });

            // get table data
            this.getData();
        }
    }
</script>

<style scoped>

    .list-complete-enter, .list-complete-leave-to {
        opacity: 0;
    }

    .list-complete-leave {
        transition: opacity 0.5s;
    }

    .list-complete-enter-to {
        transition: opacity 1.5s;
    }
</style>
